// rendered inside of xd-v1-contact-us.liquid file

// xd-v1-topSelling.liquid start

function initializeSwiper(
  swiperClass,
  navigationSwiperClass,
  initialSlides,
  initialSpace
) {
  return new Swiper(swiperClass, {
    breakpoints: {
      0: {
        slidesPerView: initialSlides,
        observer: true,
        observeParents: true,
        grid: {
          rows: 2,
          spaceBetween: initialSpace,
        },
      },
      420: {
        slidesPerView: 3.1,
        spaceBetween: 10,
        grid: {
          rows: 2,
          spaceBetween: 20,
        },
      },
      700: {
        slidesPerView: 5.5,
        spaceBetween: 20,
        grid: {
          rows: 1,
          spaceBetween: 20,
        },
      },
      1240: {
        slidesPerView: 6.5,
        spaceBetween: 20,
      },
      1520: {
        slidesPerView: 7.5,
        spaceBetween: 30,
      },
      1700: {
        slidesPerView: 8.5,
        spaceBetween: 30,
      },
    },
    navigation: {
      nextEl: `${navigationSwiperClass} .swiper-button-next`,
      prevEl: `${navigationSwiperClass} .swiper-button-prev`,
    },
  });
}

var swiperCars = initializeSwiper(
  ".swiper-topSelling-cars",
  "#topSelling-cars",
  2,
  20
);
var swiperTrucks = initializeSwiper(
  ".swiper-topSelling-trucks",
  "#topSelling-trucks",
  2,
  20
);
var swiperSUVs = initializeSwiper(
  ".swiper-topSelling-suvs",
  "#topSelling-suvs",
  2,
  20
);

// xd-v1-topSelling.liquid end


// xd-v1-featured-videos.liquid start
var swiperFeaturedVideos = new Swiper("#xd-v1-featured-videos .mySwiper", {
  breakpoints: {
    0: {
      slidesPerView: 1.1,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1224: {
      slidesPerView: 3,
      spaceBetween: 35,
    },
  },
  navigation: {
    nextEl: "#xd-v1-featured-videos .swiper-button-next",
    prevEl: "#xd-v1-featured-videos .swiper-button-prev",
  },
});
// xd-v1-featured-videos.liquid end

// xd-v1-endorseUS.liquid start
var swiperEndorseSwiper = new Swiper(".endorseSwiper", {
  slidesPerView: 1.2,
  spaceBetween: 20,
  breakpoints: {
    550: {
      slidesPerView: 2.2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2.5,
      spaceBetween: 20,
    },
    1240: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1520: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
  navigation: {
    nextEl: "#endorse-us .swiper-button-next",
    prevEl: "#endorse-us .swiper-button-prev",
  },
});
// xd-v1-endorseUS.liquid end
